import { render, staticRenderFns } from "./IndicadorProyectosApoyados.vue?vue&type=template&id=2950f334&scoped=true&"
import script from "./IndicadorProyectosApoyados.vue?vue&type=script&lang=js&"
export * from "./IndicadorProyectosApoyados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2950f334",
  null
  
)

export default component.exports